import { getConfig } from '@sydle/ui-utils';
import type { DraftFormButtonsSettings } from '../components/forms/one-draft-form-action-buttons/one-draft-form-action-buttons';
import { getCurrentLanguage } from '../store/env/env.selectors';
import { getState } from '../store/store';
import type { CustomFileAction } from '../components/shared/one-files/one-files.types';

const ONE_COMPONENTS_PACKAGE_IDENTIFIER = 'one-components';

export type OneComponentsPackage = {
  actionButtonsFormSettings: {
    publish?: DraftFormButtonsSettings;
    cancel?: DraftFormButtonsSettings;
  };
  cardComponents: { [key: string]: string };
  form: {
    disableFieldLocalizedFeedbacks: boolean;
    fileFieldCustomActions: CustomFileAction[];
  };
};

export function getComponentsPackageConfig(): OneComponentsPackage {
  return getConfig<OneComponentsPackage>(ONE_COMPONENTS_PACKAGE_IDENTIFIER);
}

export function getActionButtonsFormSettings(): OneComponentsPackage['actionButtonsFormSettings'] {
  const packageConfig: OneComponentsPackage = getComponentsPackageConfig();

  return {
    publish: normalizeI18NFields(filterDefinedProps(packageConfig?.actionButtonsFormSettings?.publish)),
    cancel: normalizeI18NFields(filterDefinedProps(packageConfig?.actionButtonsFormSettings?.cancel)),
  };
}

export function getCardsComponents(): OneComponentsPackage['cardComponents'] {
  const packageConfig: OneComponentsPackage = getComponentsPackageConfig();
  return packageConfig?.cardComponents;
}

export function getDisableFieldLocalizedFeedbacks(): OneComponentsPackage['form']['disableFieldLocalizedFeedbacks'] {
  const packageConfig: OneComponentsPackage = getComponentsPackageConfig();

  return packageConfig?.form?.disableFieldLocalizedFeedbacks;
}

export function getFileFieldCustomActions(): OneComponentsPackage['form']['fileFieldCustomActions'] {
  const packageConfig: OneComponentsPackage = getComponentsPackageConfig();

  return packageConfig?.form?.fileFieldCustomActions;
}

function filterDefinedProps(obj: any) {
  if (!obj) return;

  const returnObj = {};

  for (const key in obj) {
    const property = obj[key];
    if (property !== null && property !== undefined) {
      returnObj[key] = property;
    }
  }
  return returnObj;
}

function normalizeI18NFields(obj: any) {
  if (!obj) return obj;

  const currentLanguage = getCurrentLanguage(getState());

  for (const key in obj) {
    if (key.endsWith('__i18n')) {
      const i18nValue = obj[key][currentLanguage];
      if (i18nValue) {
        obj[key.replace('__i18n', '')] = i18nValue;
      }
      delete obj[key];
    }
  }
  return obj;
}
